import svgUrl from "ni:svgr;cO7KrIOhF2v-Rs8AdSjHiI45x4ikTCuQroJVQCukkcI";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const GroupLIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><rect width={10} height={10} x={5} y={5} fill="var(--tbl--colors--icons--group--transformation)" rx={5} /><rect width={10} height={10} x={5} y={17} fill="var(--tbl--colors--icons--clean--primary)" rx={5} /><rect width={10} height={10} x={17} y={5} fill="var(--tbl--colors--icons--transformation--primary)" rx={5} /><rect width={10} height={10} x={17} y={17} fill="var(--tbl--colors--icons--group--clean)" rx={5} /></svg>;
const Memo = memo(GroupLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "GroupLIcon";
}